module.exports = __webpack_public_path__ + "assets/img/hospital-02-gray.6338871c.svg";